import { SUMMARY_CAMPAIGN_LIMIT } from "../constants.js";

export default function CampaignMetricCards({ metrics, loading = false }) {
  const value = (count) => (loading ? "—" : Number(count || 0).toLocaleString());

  return (
    <div className="cg-history-metrics" aria-busy={loading}>
      <article className="cg-metric-card">
        <span>Recent campaigns</span>
        <strong>{value(metrics.total)}</strong>
        <small>Based on the latest {SUMMARY_CAMPAIGN_LIMIT} campaigns</small>
      </article>
      <article className="cg-metric-card">
        <span>Preparing</span>
        <strong>{value(metrics.preparing)}</strong>
        <small>Code preparation is in progress</small>
      </article>
      <article className="cg-metric-card">
        <span>Codes ready</span>
        <strong>{value(metrics.ready)}</strong>
        <small>Campaigns ready for use</small>
      </article>
      <article className="cg-metric-card">
        <span>Needs attention</span>
        <strong>{value(metrics.needsAttention)}</strong>
        <small>Campaigns that may need a retry</small>
      </article>
    </div>
  );
}
